export const BACKEND_SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL as string
export const CORS_ANYWHERE_URL = process.env.REACT_APP_CORS_ANYWHERE_URL as string
